import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Header.css";
import Preheader from "./Preheader";
import { FaHeart, FaShoppingBag, FaUser } from "react-icons/fa";

function Header() {
  const navigate = useNavigate();
  const userData1 = JSON.parse(sessionStorage.getItem("user"));
  const [allCategories, setAllCategories] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (!event.target.closest(".header-profile-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

        const cartData = sessionStorage.getItem("userCart");
      const wishlistData = sessionStorage.getItem("userWishlist");

  useEffect(() => {
    const updateCartAndWishlistCounts = () => {

      if (cartData) {
        try {
          const cart = JSON.parse(cartData);
          const totalItems = Object.values(cart).reduce(
            (total, item) => total + item.quantity,
            0
          );
          setCartCount(totalItems);
        } catch (error) {
          console.error("Error parsing cart data:", error);
          setCartCount(0);
        }
      } else {
        setCartCount(0);
      }

      if (wishlistData) {
        try {
          const wishlist = JSON.parse(wishlistData);
          setWishlistCount(wishlist.length);
        } catch (error) {
          console.error("Error parsing wishlist data:", error);
          setWishlistCount(0);
        }
      } else {
        setWishlistCount(0);
      }
    };

    updateCartAndWishlistCounts();

    const handleStorageChange = (e) => {
      if (e.key === "userCart" || e.key === "userWishlist") {
        updateCartAndWishlistCounts();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [cartData, wishlistData]);

  const fetchCategories = async () => {
    try {
      const categoryRes = await axios.get(
        "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_Category_CategoryList"
      );
      setAllCategories(categoryRes.data);
    } catch (error) {
      setAllCategories([]);
      console.log(error, "Error Occurred");
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      sessionStorage.clear();
      navigate("/login");
    }
  };

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
      <Preheader />
      <div className="nav-container">
        <div className="container categories-container">
          <div className="categories-scroll">
            <a href={"/"} className="nav-link text-white">
              Home
            </a>
            <a href={"/4"} className="nav-link text-white">
              Shop
            </a>
            <a href={"/3"} className="nav-link text-white">
              Sale
            </a>
            <a href={"/7"} className="nav-link text-white">
              Discount
            </a>
            {/* {allCategories.length > 0 &&
              allCategories.map((cat) => (
                <a
                  key={cat.id}
                  href={`/${cat.id}`}
                  className="nav-link text-white"
                >
                  {cat.CategoryName}
                </a>
              ))} */}
          </div>
        </div>

        <div className="w-100 nav-bottom hideondesktop">
          <a href="/" className="nav-link text-white nav-icon">
            <i className="fas fa-home fa-lg"></i>
          </a>
          
          <a href="/MyProfile/Addtocart" className="nav-link text-white nav-icon">
            <div className="icon-with-badge">
              <FaShoppingBag size={20} />
              {cartCount > 0 && (
                <span className="count-badge">{cartCount > 99 ? '99+' : cartCount}</span>
              )}
            </div>
          </a>
          
          <a href="/MyProfile/Wishlist" className="nav-link text-white nav-icon">
            <div className="icon-with-badge">
              <FaHeart size={20} />
              {wishlistCount > 0 && (
                <span className="count-badge">{wishlistCount > 99 ? '99+' : wishlistCount}</span>
              )}
            </div>
          </a>

          <a href="/TrackYourOrder/myOrders" className="nav-link text-white nav-icon">
            <i className="fas fa-truck fa-lg"></i>
          </a>

          {userData1 && userData1.email ? (
            <div className="header-profile-dropdown nav-icon">
              <a
                href="#"
                className="header-profile-dropdown nav-link text-white"
                onClick={(e) => {
                  e.preventDefault();
                  setShowDropdown(!showDropdown);
                }}
              >
                <FaUser size={20} />
              </a>
              {showDropdown && (
                <div className="header-dropdown-menu">
                  <button onClick={() => navigate("/myProfile")} className="header-dropdown-item">
                    My Profile
                  </button>
                  <button
                    className="header-dropdown-item header-dropdown-logout"
                    onClick={handleLogout}
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <a
              href="#"
              className="nav-link text-white nav-icon"
              onClick={handleLoginRedirect}
            >
              <FaUser size={20} />
            </a>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;